module.exports = "<div ng-repeat=\"dataItem in scheduledItem.getDataItems()\" class=\"<%= list__data %>\">\r\n    <div class=\"<%= list__dataLabel %>\">{{ dataItem.getPropertyInfo().getLabel() }}</div>\r\n    <gw-schedule-data-item item=\"dataItem\" type=\"readonly-form\"></gw-schedule-data-item>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/list/SimpleList/SimpleList.html
// module id = 1003
// module chunks = 0